module.exports = __webpack_public_path__ + "static/media/logo_1p5x.ee5f4752.png";